import React, { useEffect } from "react";
import { NotificationCard, NotificationContainer } from "./Notification.styled";
import { DATETIME_OPTIONS } from "../../constants";
import { useLocation, useNavigate } from "react-router-dom";
import { markNotificationAsRead } from "../../feature/notification/NotificationActions";
import { useDispatch } from "react-redux";

const Notification = () => {
  const location = useLocation();
  const notification = location.state !== null && location.state;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state === null) {
      navigate("/notifications");
    }
  }, [location.state, navigate]);

  useEffect(() => {
    !notification.is_read &&
      dispatch(markNotificationAsRead({ id: notification.id }));
  }, [dispatch, location.state, notification]);

  return (
    <NotificationContainer>
      <NotificationCard>
        <div>
          <h4 style={{ marginBlock: "0 15px" }}>
            {notification && notification.subject}
          </h4>
          <div>{notification && notification.message}</div>
          <div style={{ marginBlock: "50px 0px" }}>
            {new Intl.DateTimeFormat("default", DATETIME_OPTIONS).format(
              new Date(notification && notification.date)
            )}
          </div>
        </div>
      </NotificationCard>
    </NotificationContainer>
  );
};

export default Notification;
